module.exports = __webpack_public_path__ + "img/191ad4bb3432b0dcb8cdffd740ad78a4.png";